<template>
  <div>
    <!--    <v-radio-group v-model="radioSelected" @change="changes" required>-->
    <!--      <v-radio v-for="(item , i) in items" :label="item.text" :value="item.id"  :key="i"></v-radio>-->
    <!--    </v-radio-group>-->
    <div :class="items.length >= 7 && 'radioItemDenseArea'">
      <v-radio-group v-model="radioSelected" hide-details>
        <v-row>

          <v-col cols="12" lg="6" v-for="(item , i ) in items" :key="i" class="d-flex  my-2 pr-4"
               :class="[items.length <= 7 ? 'radioItem' : 'radioItemDense', radioSelected == item.id ? (items.length <= 7 ? 'activeOption' : 'activeOptionDense') : '']"
               @click="setRadioSelected(item.id)"
               :id="`${item.id}_option`" style="cursor: pointer">
            <div class="d-flex  flex-grow-1" style="width: 100%">
              <div class="d-flex flex-column justify-center">
                <!--          <v-fade-transition mode="out-in">-->
                <!--            <div class="selectCircleActive" :key="'i1'" v-if="item.id == radioSelected">-->
                <!--              <img src="@/assets/matchMaking/activeRadio.svg" alt="">-->
                <!--            </div>-->
                <!--            <div class="selectCircle" :key="'i2'" v-else></div>-->
                <!--          </v-fade-transition>-->
                <v-radio :value="item.id" :ripple="false">
                </v-radio>
              </div>
              <div class="" style="text-align: right;direction: ltr"
                   :class="radioSelected == item.id ? 'activeText' : 'textItem'">
                <template v-if="$vuetify.rtl">
                  {{ item.text }}
                </template>
                <template v-else>
                  {{ item.en_text }}
                </template>
              </div>
            </div>
          </v-col>
        </v-row>

      </v-radio-group>
    </div>

    <v-btn class="confirmBtn" color="#3CBE8B" block id="confirm_btn" elevation="0" @click="changes"
           v-if="$vuetify.breakpoint.lgAndUp">
      {{ $t('matchMaking.buttons.submit') }}
    </v-btn>
  </div>
</template>

<script>

export default {
  props: {
    language: {
      default: 'fa'
    },
    items: Array,
    callChangeInOption: Boolean,
    initialAnswers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      radioSelected: null,
    }
  },
  mounted() {
    this.applyInitialAnswers()
  },
  methods: {
    applyInitialAnswers() {
      const answer = this.initialAnswers?.[0]
      if (answer?.question_option_id) {
        this.radioSelected = answer.question_option_id
      }
    },
    setRadioSelected(id) {
      this.radioSelected = id
    },
    changes() {
      if (this.radioSelected) {
        this.$emit('answerHandler', [
          {
            'question_option_id': this.radioSelected,
          },
        ])
      } else {
        this.$emitEvent('notify', {color: 'red', title: this.$t('matchMaking.pleaseAnswer')});

      }
    }
  },
  watch: {
    initialAnswers: {
      handler() {
        this.applyInitialAnswers()
      },
      deep: true,
    },
    callChangeInOption(val) {
      if (val) {
        this.changes()
      }
    }
  }
}
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 800px) {
  .textItem {
    line-height: 20pt !important;
  }

  .activeText {
    line-height: 20pt !important;
  }
}

.activeOption .activeText {
  font-weight: 500;
}

.markArea {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  border: solid 1px rgb(60, 190, 139);
  background-color: rgba(209, 220, 255, 0.1);
}

.radioItem {
  font-size: 14px;
  transition: all 0.3s;
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 2px solid transparent;
  box-shadow: inset 0 0 0 1px #E1E1E1;
  background: #FFF;
  transition: all 0.3s;
  cursor: pointer;
  margin-bottom: 13px;
}

.radioItemDense {
  padding: 5px;
}


.radioItem .active {
  width: 15px;
  height: 15px;
  border-radius: 5px;
  background-color: rgb(60, 190, 139);
  margin: 0px auto;
}

.activeText {
  transition: all 0.3s;
  font-weight: 600;
  line-height: 20pt;
  font-size: 14px;
}

.radioItem:hover {
  transition: all 0.3s;
  border-color: #30a878 !important;
  //background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}


.radioItemDense .activeOption {
  border-color: transparent !important;
  box-shadow: inset 0 0 0 1px #E1E1E1 !important;
}

.activeOptionDense {
}

.activeOption {
  border: 2px solid #30a878;
  box-shadow: none;
}

.radioItemDenseArea {
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 20px;
}

.textItem {
  line-height: 20pt;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

</style>
